import Cookies from 'js-cookie';

export const redirect_home_if_sign_out = (navigate) => {
    const refreshToken = Cookies.get("refreshToken");
    if (refreshToken === undefined) {
        navigate('/');
    }
}